<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodaj cechy produkcyjne dla komponentu: <strong>{{ component.component.name }}({{ component.component.code }})</strong>
                </h1>
            </v-card-title>

            <v-card-text>
                <v-autocomplete
                    v-model="selectedProperties"
                    :items="filteredProperties"
                    :search-input.sync="search"
                    label="Cechy produkcyjne:"
                    placeholder="Wybierz cechy produkcyjne"
                    item-value="id"
                    item-text="verboseName"
                    return-object
                    chips
                    clearable
                    outlined
                    multiple
                    hide-details
                    @change="search = null"
                >
                    <template #selection="{item}">
                        <v-chip
                            close
                            @update:active="removeProperty(item)"
                        >
                            {{ item.verboseName }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onCancel"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="selectedProperties.length === 0"
                    @click="onSave"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { orderBy } from 'lodash'
export default {
    name: 'AssignProductPropertiesDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        component: {
            type: Object,
            default: null
        },
        properties: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            selectedProperties: [],
            isSaved: false,
            search: null,
        }
    },
    computed: {
        filteredProperties() {
            const componentProperties = this.component.productTypeComponentProperties || this.component.orderComponentProperties || this.component.productTypeComponentProperties || this.component.campaignComponentProperties

            const propertiesList = this.properties || []
            const properties = propertiesList.filter(property => {
                return !componentProperties.some(componentProperty => {
                    return componentProperty.productProductionPropertyId === property.id
                })
            })

            return orderBy(properties, 'name', 'asc')
        }
    },
    methods: {
        removeProperty(item) {
            this.selectedProperties.splice(this.selectedProperties.indexOf(item), 1)
        },
        onSave() {
            this.$emit('on-save', this.selectedProperties)
            this.isSaved = true
            this.onClose()
        },
        onClose() {
            if (this.selectedProperties.length > 0 && !this.isSaved) {
                this.$emit('on-save', this.selectedProperties)
            }
            this.resetData()
            this.$emit('on-close')
        },
        onCancel() {
            this.resetData()
            this.$emit('on-close')
        },
        resetData() {
            this.selectedProperties = []
            this.isSaved = false
        }
    }
}
</script>
